import { Component } from 'opus-angular-seed-core';

/**
 * This component is currently not used because radio questions are not allowed
 */
@Component({
    bindings: {
        question: '=',
        counter: '=',
        comparisonQuestion: '=',
        title: '=',
        comparisonTitle: '=',
        showAverages: '=?'
    },
    template: `
        <h4>{{ vm.counter }}. {{ vm.question.nameWithoutHtml }}</h4>
        <ul class="ticks">
            <!--NOTE: CURRENTLY ALL ELEMENTS HAVE SAME DISTANCE FROM ONE-ANOTHER (points value unused) -->
            <li ng-repeat="answer in vm.question.answerOptions">{{ answer.label }}</li>
        </ul>
        <dl >
            <dt ng-repeat-start="role in vm.EVALUATION_ROLE_ENUM.KEYS">{{ vm.EVALUATION_ROLE_ENUM.LABELS[role] }}</dt>
            <dd ng-repeat-end>
                <evaluation-public-report-partials-bar
                    average="vm.question.roleAverages[role]"
                    count="vm.question.answerOptions.length"
                    group-average="vm.question.groupRoleAverages[role]"
                    show-averages="vm.showAverages"
                    show-title="vm.comparisonQuestion!==undefined"
                    title="vm.title"
                />
                <evaluation-public-report-partials-bar
                    average="vm.comparisonQuestion.roleAverages[role]"
                    count="vm.comparisonQuestion.answerOptions.length"
                    group-average="vm.comparisonQuestion.groupRoleAverages[role]"
                    show-averages="vm.showAverages"
                    is-comparison="true"
                    title="vm.comparisonTitle"
                />
            </dd>
        </dl>
    `
})
export default class {
    constructor (EVALUATION_ROLE_ENUM) {
        this.EVALUATION_ROLE_ENUM = EVALUATION_ROLE_ENUM;
    }
}



// WEBPACK FOOTER //
// ./src/app/components/evaluation/public/report/question/radio/index.js